import React, { Component } from 'react'
import AccordionSecondary from '../../../../../components/accordion/accordion-secondary.component'
import Button from '../../../../../components/buttons/buttons.component'
import {
	NumberInput,
	TextAreaInput,
	FakePasswordInput
} from '../../../../../components/form-components/inputs.component'
import StyledInputContainer from '../../../../../components/form-components/styled-input-container.component'
import { BlockchainService } from '../../../../../services'
import { MOVEFLEX_NUMBERS } from '../../../../../constants'
import { StyledForm } from '../styles.style'
import { PointsBlock } from './points-block.component'

class MovePointsForm extends Component {
	componentWillMount() {
		this.updateSource()
	}

	updateSource = () => {
		BlockchainService.getPoints(MOVEFLEX_NUMBERS.MOVEFLEX).then(
			({ data: points }) =>
				this.props.updateSender({
					name: 'MOVEFLEX',
					id: MOVEFLEX_NUMBERS.MOVEFLEX,
					points
				})
		)
	}

	componentDidMount() {
		this.refs.accordion && this.refs.accordion.openAll()
	}

	render() {
		const {
			updateSender,
			updateReceiver,
			options,
			sender,
			receiver
		} = this.props

		const getNameByNumber = number => {
			return options
				.filter(option => option.value === number)
				.map(option => option.label)[0]
		}

		const onValueChange = update => moveflexNumber => {
			if (!moveflexNumber) {
				update(null)
				return
			}

			BlockchainService.getPoints(moveflexNumber).then(({ data: points }) =>
				update({
					name: getNameByNumber(moveflexNumber),
					id: moveflexNumber,
					points: points
				})
			)
		}

		return (
			<StyledForm
				className="form"
				onSubmit={this.props.handleSubmit}
				noValidate>
				<AccordionSecondary
					ref="accordion"
					arrow={false}
					multiple={true}
					noClickable
					noAnimated
					items={[
						{
							title: 'De',
							initiallyOpened: true,
							content: (
								<div style={{ paddingBottom: '1rem' }}>
									<PointsBlock
										id="sourceMoveflexNumber"
										onValueChange={onValueChange(updateSender)}
										points={!!sender ? sender.points : 0}
										initialSearchValue="Muviflex - 00000000001"
										{...this.props}
									/>
								</div>
							)
						},
						{
							title: 'Para',
							initiallyOpened: true,
							content: (
								<div className="fields">
									<StyledInputContainer className="input-container">
										<PointsBlock
											id="destinationMoveflexNumber"
											onValueChange={onValueChange(updateReceiver)}
											defaultValue={null}
											points={!!receiver ? receiver.points : 0}
											{...this.props}
										/>
									</StyledInputContainer>
									<StyledInputContainer className="input-container">
										<NumberInput
											id="value"
											label="Quantidade de pontos *"
											{...this.props}
										/>
									</StyledInputContainer>
									<StyledInputContainer className="input-container">
										<FakePasswordInput
											id="securityKey"
											label="Chave de segurança *"
											maxLength={4}
											{...this.props}
										/>
									</StyledInputContainer>
									<StyledInputContainer className="input-container">
										<TextAreaInput
											id="notes"
											label="Observação *"
											rows="2"
											{...this.props}
										/>
									</StyledInputContainer>
								</div>
							)
						}
					]}
				/>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button data-permission='10B2754869FE419FD78190865C1B46E54881C83F' primary type="submit">
						Movimentar pontos
					</Button>
				</div>
			</StyledForm>
		)
	}
}

export default MovePointsForm
